import { jsxs as vt, jsx as Ee } from "react/jsx-runtime";
import { useRef as re, useCallback as ne, useEffect as se, useMemo as bn, cloneElement as wn, Component as On, useLayoutEffect as xn, useReducer as Sn, forwardRef as Cn } from "react";
import { g as Tn } from "./_commonjsHelpers-d4512b9c.mjs";
import { _ as mt } from "./tslib.es6-59e1c9d8.mjs";
import { u as Oe } from "./index-6a632112.mjs";
import { S as Dn } from "./caretDown-8ff83493.mjs";
import { S as Rn } from "./caretUp-e6db3a6f.mjs";
import { r as Nn, s as et, b as Pn } from "./themes-5f0b3c3d.mjs";
import "./types-b577bf77.mjs";
function ce(t, n) {
  if (t == null)
    return {};
  var r = {}, o = Object.keys(t), i, e;
  for (e = 0; e < o.length; e++)
    i = o[e], !(n.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
function F() {
  return F = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
    }
    return t;
  }, F.apply(this, arguments);
}
function _t(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function qe(t, n) {
  return qe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
    return o.__proto__ = i, o;
  }, qe(t, n);
}
function Mn(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, qe(t, n);
}
var ze = { exports: {} }, Se = { exports: {} }, q = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yt;
function An() {
  if (yt)
    return q;
  yt = 1;
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, d = t ? Symbol.for("react.context") : 60110, _ = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, h = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, D = t ? Symbol.for("react.suspense_list") : 60120, V = t ? Symbol.for("react.memo") : 60115, L = t ? Symbol.for("react.lazy") : 60116, k = t ? Symbol.for("react.block") : 60121, B = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, s = t ? Symbol.for("react.scope") : 60119;
  function p(c) {
    if (typeof c == "object" && c !== null) {
      var T = c.$$typeof;
      switch (T) {
        case n:
          switch (c = c.type, c) {
            case _:
            case m:
            case o:
            case e:
            case i:
            case f:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case d:
                case h:
                case L:
                case V:
                case u:
                  return c;
                default:
                  return T;
              }
          }
        case r:
          return T;
      }
    }
  }
  function a(c) {
    return p(c) === m;
  }
  return q.AsyncMode = _, q.ConcurrentMode = m, q.ContextConsumer = d, q.ContextProvider = u, q.Element = n, q.ForwardRef = h, q.Fragment = o, q.Lazy = L, q.Memo = V, q.Portal = r, q.Profiler = e, q.StrictMode = i, q.Suspense = f, q.isAsyncMode = function(c) {
    return a(c) || p(c) === _;
  }, q.isConcurrentMode = a, q.isContextConsumer = function(c) {
    return p(c) === d;
  }, q.isContextProvider = function(c) {
    return p(c) === u;
  }, q.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === n;
  }, q.isForwardRef = function(c) {
    return p(c) === h;
  }, q.isFragment = function(c) {
    return p(c) === o;
  }, q.isLazy = function(c) {
    return p(c) === L;
  }, q.isMemo = function(c) {
    return p(c) === V;
  }, q.isPortal = function(c) {
    return p(c) === r;
  }, q.isProfiler = function(c) {
    return p(c) === e;
  }, q.isStrictMode = function(c) {
    return p(c) === i;
  }, q.isSuspense = function(c) {
    return p(c) === f;
  }, q.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === o || c === m || c === e || c === i || c === f || c === D || typeof c == "object" && c !== null && (c.$$typeof === L || c.$$typeof === V || c.$$typeof === u || c.$$typeof === d || c.$$typeof === h || c.$$typeof === B || c.$$typeof === O || c.$$typeof === s || c.$$typeof === k);
  }, q.typeOf = p, q;
}
var z = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var It;
function Vn() {
  return It || (It = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, d = t ? Symbol.for("react.context") : 60110, _ = t ? Symbol.for("react.async_mode") : 60111, m = t ? Symbol.for("react.concurrent_mode") : 60111, h = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, D = t ? Symbol.for("react.suspense_list") : 60120, V = t ? Symbol.for("react.memo") : 60115, L = t ? Symbol.for("react.lazy") : 60116, k = t ? Symbol.for("react.block") : 60121, B = t ? Symbol.for("react.fundamental") : 60117, O = t ? Symbol.for("react.responder") : 60118, s = t ? Symbol.for("react.scope") : 60119;
    function p(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === o || v === m || v === e || v === i || v === f || v === D || typeof v == "object" && v !== null && (v.$$typeof === L || v.$$typeof === V || v.$$typeof === u || v.$$typeof === d || v.$$typeof === h || v.$$typeof === B || v.$$typeof === O || v.$$typeof === s || v.$$typeof === k);
    }
    function a(v) {
      if (typeof v == "object" && v !== null) {
        var J = v.$$typeof;
        switch (J) {
          case n:
            var Q = v.type;
            switch (Q) {
              case _:
              case m:
              case o:
              case e:
              case i:
              case f:
                return Q;
              default:
                var de = Q && Q.$$typeof;
                switch (de) {
                  case d:
                  case h:
                  case L:
                  case V:
                  case u:
                    return de;
                  default:
                    return J;
                }
            }
          case r:
            return J;
        }
      }
    }
    var c = _, T = m, R = d, S = u, N = n, j = h, P = o, Y = L, I = V, U = r, W = e, Z = i, ee = f, oe = !1;
    function ue(v) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), g(v) || a(v) === _;
    }
    function g(v) {
      return a(v) === m;
    }
    function w(v) {
      return a(v) === d;
    }
    function H(v) {
      return a(v) === u;
    }
    function $(v) {
      return typeof v == "object" && v !== null && v.$$typeof === n;
    }
    function E(v) {
      return a(v) === h;
    }
    function x(v) {
      return a(v) === o;
    }
    function y(v) {
      return a(v) === L;
    }
    function C(v) {
      return a(v) === V;
    }
    function M(v) {
      return a(v) === r;
    }
    function K(v) {
      return a(v) === e;
    }
    function A(v) {
      return a(v) === i;
    }
    function b(v) {
      return a(v) === f;
    }
    z.AsyncMode = c, z.ConcurrentMode = T, z.ContextConsumer = R, z.ContextProvider = S, z.Element = N, z.ForwardRef = j, z.Fragment = P, z.Lazy = Y, z.Memo = I, z.Portal = U, z.Profiler = W, z.StrictMode = Z, z.Suspense = ee, z.isAsyncMode = ue, z.isConcurrentMode = g, z.isContextConsumer = w, z.isContextProvider = H, z.isElement = $, z.isForwardRef = E, z.isFragment = x, z.isLazy = y, z.isMemo = C, z.isPortal = M, z.isProfiler = K, z.isStrictMode = A, z.isSuspense = b, z.isValidElementType = p, z.typeOf = a;
  }()), z;
}
var Et;
function Bt() {
  return Et || (Et = 1, process.env.NODE_ENV === "production" ? Se.exports = An() : Se.exports = Vn()), Se.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ke, bt;
function kn() {
  if (bt)
    return Ke;
  bt = 1;
  var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function o(e) {
    if (e == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var e = new String("abc");
      if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
        return !1;
      for (var u = {}, d = 0; d < 10; d++)
        u["_" + String.fromCharCode(d)] = d;
      var _ = Object.getOwnPropertyNames(u).map(function(h) {
        return u[h];
      });
      if (_.join("") !== "0123456789")
        return !1;
      var m = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        m[h] = h;
      }), Object.keys(Object.assign({}, m)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ke = i() ? Object.assign : function(e, u) {
    for (var d, _ = o(e), m, h = 1; h < arguments.length; h++) {
      d = Object(arguments[h]);
      for (var f in d)
        n.call(d, f) && (_[f] = d[f]);
      if (t) {
        m = t(d);
        for (var D = 0; D < m.length; D++)
          r.call(d, m[D]) && (_[m[D]] = d[m[D]]);
      }
    }
    return _;
  }, Ke;
}
var Le, wt;
function tt() {
  if (wt)
    return Le;
  wt = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Le = t, Le;
}
var je, Ot;
function Kt() {
  return Ot || (Ot = 1, je = Function.call.bind(Object.prototype.hasOwnProperty)), je;
}
var Fe, xt;
function $n() {
  if (xt)
    return Fe;
  xt = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = tt(), r = {}, o = Kt();
    t = function(e) {
      var u = "Warning: " + e;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function i(e, u, d, _, m) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in e)
        if (o(e, h)) {
          var f;
          try {
            if (typeof e[h] != "function") {
              var D = Error(
                (_ || "React class") + ": " + d + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw D.name = "Invariant Violation", D;
            }
            f = e[h](u, h, _, d, null, n);
          } catch (L) {
            f = L;
          }
          if (f && !(f instanceof Error) && t(
            (_ || "React class") + ": type specification of " + d + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var V = m ? m() : "";
            t(
              "Failed " + d + " type: " + f.message + (V ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Fe = i, Fe;
}
var Ye, St;
function Hn() {
  if (St)
    return Ye;
  St = 1;
  var t = Bt(), n = kn(), r = tt(), o = Kt(), i = $n(), e = function() {
  };
  process.env.NODE_ENV !== "production" && (e = function(d) {
    var _ = "Warning: " + d;
    typeof console < "u" && console.error(_);
    try {
      throw new Error(_);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return Ye = function(d, _) {
    var m = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function f(g) {
      var w = g && (m && g[m] || g[h]);
      if (typeof w == "function")
        return w;
    }
    var D = "<<anonymous>>", V = {
      array: O("array"),
      bigint: O("bigint"),
      bool: O("boolean"),
      func: O("function"),
      number: O("number"),
      object: O("object"),
      string: O("string"),
      symbol: O("symbol"),
      any: s(),
      arrayOf: p,
      element: a(),
      elementType: c(),
      instanceOf: T,
      node: j(),
      objectOf: S,
      oneOf: R,
      oneOfType: N,
      shape: Y,
      exact: I
    };
    function L(g, w) {
      return g === w ? g !== 0 || 1 / g === 1 / w : g !== g && w !== w;
    }
    function k(g, w) {
      this.message = g, this.data = w && typeof w == "object" ? w : {}, this.stack = "";
    }
    k.prototype = Error.prototype;
    function B(g) {
      if (process.env.NODE_ENV !== "production")
        var w = {}, H = 0;
      function $(x, y, C, M, K, A, b) {
        if (M = M || D, A = A || C, b !== r) {
          if (_) {
            var v = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw v.name = "Invariant Violation", v;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var J = M + ":" + C;
            !w[J] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (e(
              "You are manually calling a React.PropTypes validation function for the `" + A + "` prop on `" + M + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), w[J] = !0, H++);
          }
        }
        return y[C] == null ? x ? y[C] === null ? new k("The " + K + " `" + A + "` is marked as required " + ("in `" + M + "`, but its value is `null`.")) : new k("The " + K + " `" + A + "` is marked as required in " + ("`" + M + "`, but its value is `undefined`.")) : null : g(y, C, M, K, A);
      }
      var E = $.bind(null, !1);
      return E.isRequired = $.bind(null, !0), E;
    }
    function O(g) {
      function w(H, $, E, x, y, C) {
        var M = H[$], K = Z(M);
        if (K !== g) {
          var A = ee(M);
          return new k(
            "Invalid " + x + " `" + y + "` of type " + ("`" + A + "` supplied to `" + E + "`, expected ") + ("`" + g + "`."),
            { expectedType: g }
          );
        }
        return null;
      }
      return B(w);
    }
    function s() {
      return B(u);
    }
    function p(g) {
      function w(H, $, E, x, y) {
        if (typeof g != "function")
          return new k("Property `" + y + "` of component `" + E + "` has invalid PropType notation inside arrayOf.");
        var C = H[$];
        if (!Array.isArray(C)) {
          var M = Z(C);
          return new k("Invalid " + x + " `" + y + "` of type " + ("`" + M + "` supplied to `" + E + "`, expected an array."));
        }
        for (var K = 0; K < C.length; K++) {
          var A = g(C, K, E, x, y + "[" + K + "]", r);
          if (A instanceof Error)
            return A;
        }
        return null;
      }
      return B(w);
    }
    function a() {
      function g(w, H, $, E, x) {
        var y = w[H];
        if (!d(y)) {
          var C = Z(y);
          return new k("Invalid " + E + " `" + x + "` of type " + ("`" + C + "` supplied to `" + $ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return B(g);
    }
    function c() {
      function g(w, H, $, E, x) {
        var y = w[H];
        if (!t.isValidElementType(y)) {
          var C = Z(y);
          return new k("Invalid " + E + " `" + x + "` of type " + ("`" + C + "` supplied to `" + $ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return B(g);
    }
    function T(g) {
      function w(H, $, E, x, y) {
        if (!(H[$] instanceof g)) {
          var C = g.name || D, M = ue(H[$]);
          return new k("Invalid " + x + " `" + y + "` of type " + ("`" + M + "` supplied to `" + E + "`, expected ") + ("instance of `" + C + "`."));
        }
        return null;
      }
      return B(w);
    }
    function R(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? e(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : e("Invalid argument supplied to oneOf, expected an array.")), u;
      function w(H, $, E, x, y) {
        for (var C = H[$], M = 0; M < g.length; M++)
          if (L(C, g[M]))
            return null;
        var K = JSON.stringify(g, function(b, v) {
          var J = ee(v);
          return J === "symbol" ? String(v) : v;
        });
        return new k("Invalid " + x + " `" + y + "` of value `" + String(C) + "` " + ("supplied to `" + E + "`, expected one of " + K + "."));
      }
      return B(w);
    }
    function S(g) {
      function w(H, $, E, x, y) {
        if (typeof g != "function")
          return new k("Property `" + y + "` of component `" + E + "` has invalid PropType notation inside objectOf.");
        var C = H[$], M = Z(C);
        if (M !== "object")
          return new k("Invalid " + x + " `" + y + "` of type " + ("`" + M + "` supplied to `" + E + "`, expected an object."));
        for (var K in C)
          if (o(C, K)) {
            var A = g(C, K, E, x, y + "." + K, r);
            if (A instanceof Error)
              return A;
          }
        return null;
      }
      return B(w);
    }
    function N(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && e("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var w = 0; w < g.length; w++) {
        var H = g[w];
        if (typeof H != "function")
          return e(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(H) + " at index " + w + "."
          ), u;
      }
      function $(E, x, y, C, M) {
        for (var K = [], A = 0; A < g.length; A++) {
          var b = g[A], v = b(E, x, y, C, M, r);
          if (v == null)
            return null;
          v.data && o(v.data, "expectedType") && K.push(v.data.expectedType);
        }
        var J = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new k("Invalid " + C + " `" + M + "` supplied to " + ("`" + y + "`" + J + "."));
      }
      return B($);
    }
    function j() {
      function g(w, H, $, E, x) {
        return U(w[H]) ? null : new k("Invalid " + E + " `" + x + "` supplied to " + ("`" + $ + "`, expected a ReactNode."));
      }
      return B(g);
    }
    function P(g, w, H, $, E) {
      return new k(
        (g || "React class") + ": " + w + " type `" + H + "." + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`."
      );
    }
    function Y(g) {
      function w(H, $, E, x, y) {
        var C = H[$], M = Z(C);
        if (M !== "object")
          return new k("Invalid " + x + " `" + y + "` of type `" + M + "` " + ("supplied to `" + E + "`, expected `object`."));
        for (var K in g) {
          var A = g[K];
          if (typeof A != "function")
            return P(E, x, y, K, ee(A));
          var b = A(C, K, E, x, y + "." + K, r);
          if (b)
            return b;
        }
        return null;
      }
      return B(w);
    }
    function I(g) {
      function w(H, $, E, x, y) {
        var C = H[$], M = Z(C);
        if (M !== "object")
          return new k("Invalid " + x + " `" + y + "` of type `" + M + "` " + ("supplied to `" + E + "`, expected `object`."));
        var K = n({}, H[$], g);
        for (var A in K) {
          var b = g[A];
          if (o(g, A) && typeof b != "function")
            return P(E, x, y, A, ee(b));
          if (!b)
            return new k(
              "Invalid " + x + " `" + y + "` key `" + A + "` supplied to `" + E + "`.\nBad object: " + JSON.stringify(H[$], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(g), null, "  ")
            );
          var v = b(C, A, E, x, y + "." + A, r);
          if (v)
            return v;
        }
        return null;
      }
      return B(w);
    }
    function U(g) {
      switch (typeof g) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !g;
        case "object":
          if (Array.isArray(g))
            return g.every(U);
          if (g === null || d(g))
            return !0;
          var w = f(g);
          if (w) {
            var H = w.call(g), $;
            if (w !== g.entries) {
              for (; !($ = H.next()).done; )
                if (!U($.value))
                  return !1;
            } else
              for (; !($ = H.next()).done; ) {
                var E = $.value;
                if (E && !U(E[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(g, w) {
      return g === "symbol" ? !0 : w ? w["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && w instanceof Symbol : !1;
    }
    function Z(g) {
      var w = typeof g;
      return Array.isArray(g) ? "array" : g instanceof RegExp ? "object" : W(w, g) ? "symbol" : w;
    }
    function ee(g) {
      if (typeof g > "u" || g === null)
        return "" + g;
      var w = Z(g);
      if (w === "object") {
        if (g instanceof Date)
          return "date";
        if (g instanceof RegExp)
          return "regexp";
      }
      return w;
    }
    function oe(g) {
      var w = ee(g);
      switch (w) {
        case "array":
        case "object":
          return "an " + w;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + w;
        default:
          return w;
      }
    }
    function ue(g) {
      return !g.constructor || !g.constructor.name ? D : g.constructor.name;
    }
    return V.checkPropTypes = i, V.resetWarningCache = i.resetWarningCache, V.PropTypes = V, V;
  }, Ye;
}
var We, Ct;
function Bn() {
  if (Ct)
    return We;
  Ct = 1;
  var t = tt();
  function n() {
  }
  function r() {
  }
  return r.resetWarningCache = n, We = function() {
    function o(u, d, _, m, h, f) {
      if (f !== t) {
        var D = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw D.name = "Invariant Violation", D;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var e = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: n
    };
    return e.PropTypes = e, e;
  }, We;
}
if (process.env.NODE_ENV !== "production") {
  var Kn = Bt(), Ln = !0;
  ze.exports = Hn()(Kn.isElement, Ln);
} else
  ze.exports = Bn()();
var jn = ze.exports;
const l = /* @__PURE__ */ Tn(jn);
var Ge = { exports: {} }, G = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tt;
function Fn() {
  if (Tt)
    return G;
  Tt = 1;
  var t = 60103, n = 60106, r = 60107, o = 60108, i = 60114, e = 60109, u = 60110, d = 60112, _ = 60113, m = 60120, h = 60115, f = 60116, D = 60121, V = 60122, L = 60117, k = 60129, B = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var O = Symbol.for;
    t = O("react.element"), n = O("react.portal"), r = O("react.fragment"), o = O("react.strict_mode"), i = O("react.profiler"), e = O("react.provider"), u = O("react.context"), d = O("react.forward_ref"), _ = O("react.suspense"), m = O("react.suspense_list"), h = O("react.memo"), f = O("react.lazy"), D = O("react.block"), V = O("react.server.block"), L = O("react.fundamental"), k = O("react.debug_trace_mode"), B = O("react.legacy_hidden");
  }
  function s(I) {
    if (typeof I == "object" && I !== null) {
      var U = I.$$typeof;
      switch (U) {
        case t:
          switch (I = I.type, I) {
            case r:
            case i:
            case o:
            case _:
            case m:
              return I;
            default:
              switch (I = I && I.$$typeof, I) {
                case u:
                case d:
                case f:
                case h:
                case e:
                  return I;
                default:
                  return U;
              }
          }
        case n:
          return U;
      }
    }
  }
  var p = e, a = t, c = d, T = r, R = f, S = h, N = n, j = i, P = o, Y = _;
  return G.ContextConsumer = u, G.ContextProvider = p, G.Element = a, G.ForwardRef = c, G.Fragment = T, G.Lazy = R, G.Memo = S, G.Portal = N, G.Profiler = j, G.StrictMode = P, G.Suspense = Y, G.isAsyncMode = function() {
    return !1;
  }, G.isConcurrentMode = function() {
    return !1;
  }, G.isContextConsumer = function(I) {
    return s(I) === u;
  }, G.isContextProvider = function(I) {
    return s(I) === e;
  }, G.isElement = function(I) {
    return typeof I == "object" && I !== null && I.$$typeof === t;
  }, G.isForwardRef = function(I) {
    return s(I) === d;
  }, G.isFragment = function(I) {
    return s(I) === r;
  }, G.isLazy = function(I) {
    return s(I) === f;
  }, G.isMemo = function(I) {
    return s(I) === h;
  }, G.isPortal = function(I) {
    return s(I) === n;
  }, G.isProfiler = function(I) {
    return s(I) === i;
  }, G.isStrictMode = function(I) {
    return s(I) === o;
  }, G.isSuspense = function(I) {
    return s(I) === _;
  }, G.isValidElementType = function(I) {
    return typeof I == "string" || typeof I == "function" || I === r || I === i || I === k || I === o || I === _ || I === m || I === B || typeof I == "object" && I !== null && (I.$$typeof === f || I.$$typeof === h || I.$$typeof === e || I.$$typeof === u || I.$$typeof === d || I.$$typeof === L || I.$$typeof === D || I[0] === V);
  }, G.typeOf = s, G;
}
var X = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dt;
function Yn() {
  return Dt || (Dt = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, n = 60106, r = 60107, o = 60108, i = 60114, e = 60109, u = 60110, d = 60112, _ = 60113, m = 60120, h = 60115, f = 60116, D = 60121, V = 60122, L = 60117, k = 60129, B = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var O = Symbol.for;
      t = O("react.element"), n = O("react.portal"), r = O("react.fragment"), o = O("react.strict_mode"), i = O("react.profiler"), e = O("react.provider"), u = O("react.context"), d = O("react.forward_ref"), _ = O("react.suspense"), m = O("react.suspense_list"), h = O("react.memo"), f = O("react.lazy"), D = O("react.block"), V = O("react.server.block"), L = O("react.fundamental"), O("react.scope"), O("react.opaque.id"), k = O("react.debug_trace_mode"), O("react.offscreen"), B = O("react.legacy_hidden");
    }
    var s = !1;
    function p(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === r || b === i || b === k || b === o || b === _ || b === m || b === B || s || typeof b == "object" && b !== null && (b.$$typeof === f || b.$$typeof === h || b.$$typeof === e || b.$$typeof === u || b.$$typeof === d || b.$$typeof === L || b.$$typeof === D || b[0] === V));
    }
    function a(b) {
      if (typeof b == "object" && b !== null) {
        var v = b.$$typeof;
        switch (v) {
          case t:
            var J = b.type;
            switch (J) {
              case r:
              case i:
              case o:
              case _:
              case m:
                return J;
              default:
                var Q = J && J.$$typeof;
                switch (Q) {
                  case u:
                  case d:
                  case f:
                  case h:
                  case e:
                    return Q;
                  default:
                    return v;
                }
            }
          case n:
            return v;
        }
      }
    }
    var c = u, T = e, R = t, S = d, N = r, j = f, P = h, Y = n, I = i, U = o, W = _, Z = !1, ee = !1;
    function oe(b) {
      return Z || (Z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ue(b) {
      return ee || (ee = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function g(b) {
      return a(b) === u;
    }
    function w(b) {
      return a(b) === e;
    }
    function H(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function $(b) {
      return a(b) === d;
    }
    function E(b) {
      return a(b) === r;
    }
    function x(b) {
      return a(b) === f;
    }
    function y(b) {
      return a(b) === h;
    }
    function C(b) {
      return a(b) === n;
    }
    function M(b) {
      return a(b) === i;
    }
    function K(b) {
      return a(b) === o;
    }
    function A(b) {
      return a(b) === _;
    }
    X.ContextConsumer = c, X.ContextProvider = T, X.Element = R, X.ForwardRef = S, X.Fragment = N, X.Lazy = j, X.Memo = P, X.Portal = Y, X.Profiler = I, X.StrictMode = U, X.Suspense = W, X.isAsyncMode = oe, X.isConcurrentMode = ue, X.isContextConsumer = g, X.isContextProvider = w, X.isElement = H, X.isForwardRef = $, X.isFragment = E, X.isLazy = x, X.isMemo = y, X.isPortal = C, X.isProfiler = M, X.isStrictMode = K, X.isSuspense = A, X.isValidElementType = p, X.typeOf = a;
  }()), X;
}
process.env.NODE_ENV === "production" ? Ge.exports = Fn() : Ge.exports = Yn();
var Rt = Ge.exports;
let Nt = (t) => typeof t == "object" && t != null && t.nodeType === 1, Pt = (t, n) => (!n || t !== "hidden") && t !== "visible" && t !== "clip", Ue = (t, n) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    let r = getComputedStyle(t, null);
    return Pt(r.overflowY, n) || Pt(r.overflowX, n) || ((o) => {
      let i = ((e) => {
        if (!e.ownerDocument || !e.ownerDocument.defaultView)
          return null;
        try {
          return e.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!i && (i.clientHeight < o.scrollHeight || i.clientWidth < o.scrollWidth);
    })(t);
  }
  return !1;
}, Ce = (t, n, r, o, i, e, u, d) => e < t && u > n || e > t && u < n ? 0 : e <= t && d <= r || u >= n && d >= r ? e - t - o : u > n && d < r || e < t && d > r ? u - n + i : 0, Wn = (t) => {
  let n = t.parentElement;
  return n ?? (t.getRootNode().host || null);
};
var Un = (t, n) => {
  var r, o, i, e, u, d;
  if (typeof document > "u")
    return [];
  let { scrollMode: _, block: m, inline: h, boundary: f, skipOverflowHiddenElements: D } = n, V = typeof f == "function" ? f : (U) => U !== f;
  if (!Nt(t))
    throw new TypeError("Invalid target");
  let L = document.scrollingElement || document.documentElement, k = [], B = t;
  for (; Nt(B) && V(B); ) {
    if (B = Wn(B), B === L) {
      k.push(B);
      break;
    }
    B != null && B === document.body && Ue(B) && !Ue(document.documentElement) || B != null && Ue(B, D) && k.push(B);
  }
  let O = (o = (r = window.visualViewport) == null ? void 0 : r.width) != null ? o : innerWidth, s = (e = (i = window.visualViewport) == null ? void 0 : i.height) != null ? e : innerHeight, p = (u = window.scrollX) != null ? u : pageXOffset, a = (d = window.scrollY) != null ? d : pageYOffset, { height: c, width: T, top: R, right: S, bottom: N, left: j } = t.getBoundingClientRect(), P = m === "start" || m === "nearest" ? R : m === "end" ? N : R + c / 2, Y = h === "center" ? j + T / 2 : h === "end" ? S : j, I = [];
  for (let U = 0; U < k.length; U++) {
    let W = k[U], { height: Z, width: ee, top: oe, right: ue, bottom: g, left: w } = W.getBoundingClientRect();
    if (_ === "if-needed" && R >= 0 && j >= 0 && N <= s && S <= O && R >= oe && N <= g && j >= w && S <= ue)
      return I;
    let H = getComputedStyle(W), $ = parseInt(H.borderLeftWidth, 10), E = parseInt(H.borderTopWidth, 10), x = parseInt(H.borderRightWidth, 10), y = parseInt(H.borderBottomWidth, 10), C = 0, M = 0, K = "offsetWidth" in W ? W.offsetWidth - W.clientWidth - $ - x : 0, A = "offsetHeight" in W ? W.offsetHeight - W.clientHeight - E - y : 0, b = "offsetWidth" in W ? W.offsetWidth === 0 ? 0 : ee / W.offsetWidth : 0, v = "offsetHeight" in W ? W.offsetHeight === 0 ? 0 : Z / W.offsetHeight : 0;
    if (L === W)
      C = m === "start" ? P : m === "end" ? P - s : m === "nearest" ? Ce(a, a + s, s, E, y, a + P, a + P + c, c) : P - s / 2, M = h === "start" ? Y : h === "center" ? Y - O / 2 : h === "end" ? Y - O : Ce(p, p + O, O, $, x, p + Y, p + Y + T, T), C = Math.max(0, C + a), M = Math.max(0, M + p);
    else {
      C = m === "start" ? P - oe - E : m === "end" ? P - g + y + A : m === "nearest" ? Ce(oe, g, Z, E, y + A, P, P + c, c) : P - (oe + Z / 2) + A / 2, M = h === "start" ? Y - w - $ : h === "center" ? Y - (w + ee / 2) + K / 2 : h === "end" ? Y - ue + x + K : Ce(w, ue, ee, $, x + K, Y, Y + T, T);
      let { scrollLeft: J, scrollTop: Q } = W;
      C = Math.max(0, Math.min(Q + C / v, W.scrollHeight - Z / v + A)), M = Math.max(0, Math.min(J + M / b, W.scrollWidth - ee / b + K)), P += Q - C, Y += J - M;
    }
    I.push({ el: W, top: C, left: M });
  }
  return I;
}, qn = 0;
function Mt(t) {
  return typeof t == "function" ? t : ie;
}
function ie() {
}
function Lt(t, n) {
  if (t) {
    var r = Un(t, {
      boundary: n,
      block: "nearest",
      scrollMode: "if-needed"
    });
    r.forEach(function(o) {
      var i = o.el, e = o.top, u = o.left;
      i.scrollTop = e, i.scrollLeft = u;
    });
  }
}
function At(t, n, r) {
  var o = t === n || n instanceof r.Node && t.contains && t.contains(n);
  return o;
}
function He(t, n) {
  var r;
  function o() {
    r && clearTimeout(r);
  }
  function i() {
    for (var e = arguments.length, u = new Array(e), d = 0; d < e; d++)
      u[d] = arguments[d];
    o(), r = setTimeout(function() {
      r = null, t.apply(void 0, u);
    }, n);
  }
  return i.cancel = o, i;
}
function te() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    for (var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++)
      e[u - 1] = arguments[u];
    return n.some(function(d) {
      return d && d.apply(void 0, [o].concat(e)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function be() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    n.forEach(function(i) {
      typeof i == "function" ? i(o) : i && (i.current = o);
    });
  };
}
function jt() {
  return String(qn++);
}
function Ft(t) {
  var n = t.isOpen, r = t.resultCount, o = t.previousResultCount;
  return n ? r ? r !== o ? r + " result" + (r === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Vt(t, n) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && n ? n : t;
}
function Yt(t) {
  return typeof t.type == "string";
}
function Wt(t) {
  return t.props;
}
function zn(t, n) {
  console.error('The property "' + n + '" is required in "' + t + '"');
}
var Gn = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Te(t) {
  t === void 0 && (t = {});
  var n = {};
  return Gn.forEach(function(r) {
    t.hasOwnProperty(r) && (n[r] = t[r]);
  }), n;
}
function Me(t, n) {
  return Object.keys(t).reduce(function(r, o) {
    return r[o] = Xe(n, o) ? n[o] : t[o], r;
  }, {});
}
function Xe(t, n) {
  return t[n] !== void 0;
}
function Je(t) {
  var n = t.key, r = t.keyCode;
  return r >= 37 && r <= 40 && n.indexOf("Arrow") !== 0 ? "Arrow" + n : n;
}
function Xn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function ge(t, n, r, o, i) {
  if (i === void 0 && (i = !0), r === 0)
    return -1;
  var e = r - 1;
  (typeof n != "number" || n < 0 || n >= r) && (n = t > 0 ? -1 : e + 1);
  var u = n + t;
  u < 0 ? u = i ? e : 0 : u > e && (u = i ? 0 : e);
  var d = he(t, u, r, o, i);
  return d === -1 ? n >= r ? -1 : n : d;
}
function he(t, n, r, o, i) {
  var e = o(n);
  if (!e || !e.hasAttribute("disabled"))
    return n;
  if (t > 0) {
    for (var u = n + 1; u < r; u++)
      if (!o(u).hasAttribute("disabled"))
        return u;
  } else
    for (var d = n - 1; d >= 0; d--)
      if (!o(d).hasAttribute("disabled"))
        return d;
  return i ? t > 0 ? he(1, 0, r, o, !1) : he(-1, r - 1, r, o, !1) : -1;
}
function Ae(t, n, r, o) {
  return o === void 0 && (o = !0), n.some(function(i) {
    return i && (At(i, t, r) || o && At(i, r.document.activeElement, r));
  });
}
var nt = ie;
process.env.NODE_ENV !== "production" && (nt = function(n, r, o) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(n).forEach(function(e) {
    r[e] !== void 0 && o[e] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + e + '" to be uncontrolled. ' + i) : r[e] === void 0 && o[e] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + e + '" to be controlled. ' + i);
  });
});
var Jn = He(function(t) {
  qt(t).textContent = "";
}, 500);
function Ut(t, n) {
  var r = qt(n);
  t && (r.textContent = t, Jn(n));
}
function qt(t) {
  t === void 0 && (t = document);
  var n = t.getElementById("a11y-status-message");
  return n || (n = t.createElement("div"), n.setAttribute("id", "a11y-status-message"), n.setAttribute("role", "status"), n.setAttribute("aria-live", "polite"), n.setAttribute("aria-relevant", "additions text"), Object.assign(n.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(n), n);
}
var zt = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Gt = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Xt = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Re = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Ne = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Jt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Zt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Qt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, en = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, tn = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, nn = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, rn = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, on = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Ze = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, un = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, sn = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, an = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Zn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: zt,
  mouseUp: Gt,
  itemMouseEnter: Xt,
  keyDownArrowUp: Re,
  keyDownArrowDown: Ne,
  keyDownEscape: Jt,
  keyDownEnter: Zt,
  keyDownHome: Qt,
  keyDownEnd: en,
  clickItem: tn,
  blurInput: nn,
  changeInput: rn,
  keyDownSpaceButton: on,
  clickButton: Ze,
  blurButton: un,
  controlledPropUpdatedSelectedItem: sn,
  touchEnd: an
}), Qn = ["refKey", "ref"], er = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], tr = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], nr = ["refKey", "ref"], rr = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], or = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(n) {
    Mn(r, n);
    function r(i) {
      var e;
      e = n.call(this, i) || this, e.id = e.props.id || "downshift-" + jt(), e.menuId = e.props.menuId || e.id + "-menu", e.labelId = e.props.labelId || e.id + "-label", e.inputId = e.props.inputId || e.id + "-input", e.getItemId = e.props.getItemId || function(s) {
        return e.id + "-item-" + s;
      }, e.input = null, e.items = [], e.itemCount = null, e.previousResultCount = 0, e.timeoutIds = [], e.internalSetTimeout = function(s, p) {
        var a = setTimeout(function() {
          e.timeoutIds = e.timeoutIds.filter(function(c) {
            return c !== a;
          }), s();
        }, p);
        e.timeoutIds.push(a);
      }, e.setItemCount = function(s) {
        e.itemCount = s;
      }, e.unsetItemCount = function() {
        e.itemCount = null;
      }, e.setHighlightedIndex = function(s, p) {
        s === void 0 && (s = e.props.defaultHighlightedIndex), p === void 0 && (p = {}), p = Te(p), e.internalSetState(F({
          highlightedIndex: s
        }, p));
      }, e.clearSelection = function(s) {
        e.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: e.props.defaultHighlightedIndex,
          isOpen: e.props.defaultIsOpen
        }, s);
      }, e.selectItem = function(s, p, a) {
        p = Te(p), e.internalSetState(F({
          isOpen: e.props.defaultIsOpen,
          highlightedIndex: e.props.defaultHighlightedIndex,
          selectedItem: s,
          inputValue: e.props.itemToString(s)
        }, p), a);
      }, e.selectItemAtIndex = function(s, p, a) {
        var c = e.items[s];
        c != null && e.selectItem(c, p, a);
      }, e.selectHighlightedItem = function(s, p) {
        return e.selectItemAtIndex(e.getState().highlightedIndex, s, p);
      }, e.internalSetState = function(s, p) {
        var a, c, T = {}, R = typeof s == "function";
        return !R && s.hasOwnProperty("inputValue") && e.props.onInputValueChange(s.inputValue, F({}, e.getStateAndHelpers(), s)), e.setState(function(S) {
          S = e.getState(S);
          var N = R ? s(S) : s;
          N = e.props.stateReducer(S, N), a = N.hasOwnProperty("selectedItem");
          var j = {};
          return a && N.selectedItem !== S.selectedItem && (c = N.selectedItem), N.type = N.type || zt, Object.keys(N).forEach(function(P) {
            S[P] !== N[P] && (T[P] = N[P]), P !== "type" && (N[P], Xe(e.props, P) || (j[P] = N[P]));
          }), R && N.hasOwnProperty("inputValue") && e.props.onInputValueChange(N.inputValue, F({}, e.getStateAndHelpers(), N)), j;
        }, function() {
          Mt(p)();
          var S = Object.keys(T).length > 1;
          S && e.props.onStateChange(T, e.getStateAndHelpers()), a && e.props.onSelect(s.selectedItem, e.getStateAndHelpers()), c !== void 0 && e.props.onChange(c, e.getStateAndHelpers()), e.props.onUserAction(T, e.getStateAndHelpers());
        });
      }, e.rootRef = function(s) {
        return e._rootNode = s;
      }, e.getRootProps = function(s, p) {
        var a, c = s === void 0 ? {} : s, T = c.refKey, R = T === void 0 ? "ref" : T, S = c.ref, N = ce(c, Qn), j = p === void 0 ? {} : p, P = j.suppressRefError, Y = P === void 0 ? !1 : P;
        e.getRootProps.called = !0, e.getRootProps.refKey = R, e.getRootProps.suppressRefError = Y;
        var I = e.getState(), U = I.isOpen;
        return F((a = {}, a[R] = be(S, e.rootRef), a.role = "combobox", a["aria-expanded"] = U, a["aria-haspopup"] = "listbox", a["aria-owns"] = U ? e.menuId : null, a["aria-labelledby"] = e.labelId, a), N);
      }, e.keyDownHandlers = {
        ArrowDown: function(p) {
          var a = this;
          if (p.preventDefault(), this.getState().isOpen) {
            var c = p.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(c, {
              type: Ne
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ne
            }, function() {
              var T = a.getItemCount();
              if (T > 0) {
                var R = a.getState(), S = R.highlightedIndex, N = ge(1, S, T, function(j) {
                  return a.getItemNodeFromIndex(j);
                });
                a.setHighlightedIndex(N, {
                  type: Ne
                });
              }
            });
        },
        ArrowUp: function(p) {
          var a = this;
          if (p.preventDefault(), this.getState().isOpen) {
            var c = p.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(c, {
              type: Re
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Re
            }, function() {
              var T = a.getItemCount();
              if (T > 0) {
                var R = a.getState(), S = R.highlightedIndex, N = ge(-1, S, T, function(j) {
                  return a.getItemNodeFromIndex(j);
                });
                a.setHighlightedIndex(N, {
                  type: Re
                });
              }
            });
        },
        Enter: function(p) {
          if (p.which !== 229) {
            var a = this.getState(), c = a.isOpen, T = a.highlightedIndex;
            if (c && T != null) {
              p.preventDefault();
              var R = this.items[T], S = this.getItemNodeFromIndex(T);
              if (R == null || S && S.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Zt
              });
            }
          }
        },
        Escape: function(p) {
          p.preventDefault(), this.reset(F({
            type: Jt
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, e.buttonKeyDownHandlers = F({}, e.keyDownHandlers, {
        " ": function(p) {
          p.preventDefault(), this.toggleMenu({
            type: on
          });
        }
      }), e.inputKeyDownHandlers = F({}, e.keyDownHandlers, {
        Home: function(p) {
          var a = this, c = this.getState(), T = c.isOpen;
          if (T) {
            p.preventDefault();
            var R = this.getItemCount();
            if (!(R <= 0 || !T)) {
              var S = he(1, 0, R, function(N) {
                return a.getItemNodeFromIndex(N);
              }, !1);
              this.setHighlightedIndex(S, {
                type: Qt
              });
            }
          }
        },
        End: function(p) {
          var a = this, c = this.getState(), T = c.isOpen;
          if (T) {
            p.preventDefault();
            var R = this.getItemCount();
            if (!(R <= 0 || !T)) {
              var S = he(-1, R - 1, R, function(N) {
                return a.getItemNodeFromIndex(N);
              }, !1);
              this.setHighlightedIndex(S, {
                type: en
              });
            }
          }
        }
      }), e.getToggleButtonProps = function(s) {
        var p = s === void 0 ? {} : s, a = p.onClick;
        p.onPress;
        var c = p.onKeyDown, T = p.onKeyUp, R = p.onBlur, S = ce(p, er), N = e.getState(), j = N.isOpen, P = {
          onClick: te(a, e.buttonHandleClick),
          onKeyDown: te(c, e.buttonHandleKeyDown),
          onKeyUp: te(T, e.buttonHandleKeyUp),
          onBlur: te(R, e.buttonHandleBlur)
        }, Y = S.disabled ? {} : P;
        return F({
          type: "button",
          role: "button",
          "aria-label": j ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, Y, S);
      }, e.buttonHandleKeyUp = function(s) {
        s.preventDefault();
      }, e.buttonHandleKeyDown = function(s) {
        var p = Je(s);
        e.buttonKeyDownHandlers[p] && e.buttonKeyDownHandlers[p].call(_t(e), s);
      }, e.buttonHandleClick = function(s) {
        s.preventDefault(), e.props.environment.document.activeElement === e.props.environment.document.body && s.target.focus(), process.env.NODE_ENV === "test" ? e.toggleMenu({
          type: Ze
        }) : e.internalSetTimeout(function() {
          return e.toggleMenu({
            type: Ze
          });
        });
      }, e.buttonHandleBlur = function(s) {
        var p = s.target;
        e.internalSetTimeout(function() {
          !e.isMouseDown && (e.props.environment.document.activeElement == null || e.props.environment.document.activeElement.id !== e.inputId) && e.props.environment.document.activeElement !== p && e.reset({
            type: un
          });
        });
      }, e.getLabelProps = function(s) {
        return F({
          htmlFor: e.inputId,
          id: e.labelId
        }, s);
      }, e.getInputProps = function(s) {
        var p = s === void 0 ? {} : s, a = p.onKeyDown, c = p.onBlur, T = p.onChange, R = p.onInput;
        p.onChangeText;
        var S = ce(p, tr), N, j = {};
        N = "onChange";
        var P = e.getState(), Y = P.inputValue, I = P.isOpen, U = P.highlightedIndex;
        if (!S.disabled) {
          var W;
          j = (W = {}, W[N] = te(T, R, e.inputHandleChange), W.onKeyDown = te(a, e.inputHandleKeyDown), W.onBlur = te(c, e.inputHandleBlur), W);
        }
        return F({
          "aria-autocomplete": "list",
          "aria-activedescendant": I && typeof U == "number" && U >= 0 ? e.getItemId(U) : null,
          "aria-controls": I ? e.menuId : null,
          "aria-labelledby": S && S["aria-label"] ? void 0 : e.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: Y,
          id: e.inputId
        }, j, S);
      }, e.inputHandleKeyDown = function(s) {
        var p = Je(s);
        p && e.inputKeyDownHandlers[p] && e.inputKeyDownHandlers[p].call(_t(e), s);
      }, e.inputHandleChange = function(s) {
        e.internalSetState({
          type: rn,
          isOpen: !0,
          inputValue: s.target.value,
          highlightedIndex: e.props.defaultHighlightedIndex
        });
      }, e.inputHandleBlur = function() {
        e.internalSetTimeout(function() {
          var s = e.props.environment.document && !!e.props.environment.document.activeElement && !!e.props.environment.document.activeElement.dataset && e.props.environment.document.activeElement.dataset.toggle && e._rootNode && e._rootNode.contains(e.props.environment.document.activeElement);
          !e.isMouseDown && !s && e.reset({
            type: nn
          });
        });
      }, e.menuRef = function(s) {
        e._menuNode = s;
      }, e.getMenuProps = function(s, p) {
        var a, c = s === void 0 ? {} : s, T = c.refKey, R = T === void 0 ? "ref" : T, S = c.ref, N = ce(c, nr), j = p === void 0 ? {} : p, P = j.suppressRefError, Y = P === void 0 ? !1 : P;
        return e.getMenuProps.called = !0, e.getMenuProps.refKey = R, e.getMenuProps.suppressRefError = Y, F((a = {}, a[R] = be(S, e.menuRef), a.role = "listbox", a["aria-labelledby"] = N && N["aria-label"] ? null : e.labelId, a.id = e.menuId, a), N);
      }, e.getItemProps = function(s) {
        var p, a = s === void 0 ? {} : s, c = a.onMouseMove, T = a.onMouseDown, R = a.onClick;
        a.onPress;
        var S = a.index, N = a.item, j = N === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : zn("getItemProps", "item") : N, P = ce(a, rr);
        S === void 0 ? (e.items.push(j), S = e.items.indexOf(j)) : e.items[S] = j;
        var Y = "onClick", I = R, U = (p = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: te(c, function() {
            S !== e.getState().highlightedIndex && (e.setHighlightedIndex(S, {
              type: Xt
            }), e.avoidScrolling = !0, e.internalSetTimeout(function() {
              return e.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: te(T, function(Z) {
            Z.preventDefault();
          })
        }, p[Y] = te(I, function() {
          e.selectItemAtIndex(S, {
            type: tn
          });
        }), p), W = P.disabled ? {
          onMouseDown: U.onMouseDown
        } : U;
        return F({
          id: e.getItemId(S),
          role: "option",
          "aria-selected": e.getState().highlightedIndex === S
        }, W, P);
      }, e.clearItems = function() {
        e.items = [];
      }, e.reset = function(s, p) {
        s === void 0 && (s = {}), s = Te(s), e.internalSetState(function(a) {
          var c = a.selectedItem;
          return F({
            isOpen: e.props.defaultIsOpen,
            highlightedIndex: e.props.defaultHighlightedIndex,
            inputValue: e.props.itemToString(c)
          }, s);
        }, p);
      }, e.toggleMenu = function(s, p) {
        s === void 0 && (s = {}), s = Te(s), e.internalSetState(function(a) {
          var c = a.isOpen;
          return F({
            isOpen: !c
          }, c && {
            highlightedIndex: e.props.defaultHighlightedIndex
          }, s);
        }, function() {
          var a = e.getState(), c = a.isOpen, T = a.highlightedIndex;
          c && e.getItemCount() > 0 && typeof T == "number" && e.setHighlightedIndex(T, s), Mt(p)();
        });
      }, e.openMenu = function(s) {
        e.internalSetState({
          isOpen: !0
        }, s);
      }, e.closeMenu = function(s) {
        e.internalSetState({
          isOpen: !1
        }, s);
      }, e.updateStatus = He(function() {
        var s = e.getState(), p = e.items[s.highlightedIndex], a = e.getItemCount(), c = e.props.getA11yStatusMessage(F({
          itemToString: e.props.itemToString,
          previousResultCount: e.previousResultCount,
          resultCount: a,
          highlightedItem: p
        }, s));
        e.previousResultCount = a, Ut(c, e.props.environment.document);
      }, 200);
      var u = e.props, d = u.defaultHighlightedIndex, _ = u.initialHighlightedIndex, m = _ === void 0 ? d : _, h = u.defaultIsOpen, f = u.initialIsOpen, D = f === void 0 ? h : f, V = u.initialInputValue, L = V === void 0 ? "" : V, k = u.initialSelectedItem, B = k === void 0 ? null : k, O = e.getState({
        highlightedIndex: m,
        isOpen: D,
        inputValue: L,
        selectedItem: B
      });
      return O.selectedItem != null && e.props.initialInputValue === void 0 && (O.inputValue = e.props.itemToString(O.selectedItem)), e.state = O, e;
    }
    var o = r.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(e) {
        clearTimeout(e);
      }), this.timeoutIds = [];
    }, o.getState = function(e) {
      return e === void 0 && (e = this.state), Me(e, this.props);
    }, o.getItemCount = function() {
      var e = this.items.length;
      return this.itemCount != null ? e = this.itemCount : this.props.itemCount !== void 0 && (e = this.props.itemCount), e;
    }, o.getItemNodeFromIndex = function(e) {
      return this.props.environment.document.getElementById(this.getItemId(e));
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var e = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(e, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(e, u) {
      var d = this, _ = this.getItemCount(), m = this.getState(), h = m.highlightedIndex;
      if (_ > 0) {
        var f = ge(e, h, _, function(D) {
          return d.getItemNodeFromIndex(D);
        });
        this.setHighlightedIndex(f, u);
      }
    }, o.getStateAndHelpers = function() {
      var e = this.getState(), u = e.highlightedIndex, d = e.inputValue, _ = e.selectedItem, m = e.isOpen, h = this.props.itemToString, f = this.id, D = this.getRootProps, V = this.getToggleButtonProps, L = this.getLabelProps, k = this.getMenuProps, B = this.getInputProps, O = this.getItemProps, s = this.openMenu, p = this.closeMenu, a = this.toggleMenu, c = this.selectItem, T = this.selectItemAtIndex, R = this.selectHighlightedItem, S = this.setHighlightedIndex, N = this.clearSelection, j = this.clearItems, P = this.reset, Y = this.setItemCount, I = this.unsetItemCount, U = this.internalSetState;
      return {
        // prop getters
        getRootProps: D,
        getToggleButtonProps: V,
        getLabelProps: L,
        getMenuProps: k,
        getInputProps: B,
        getItemProps: O,
        // actions
        reset: P,
        openMenu: s,
        closeMenu: p,
        toggleMenu: a,
        selectItem: c,
        selectItemAtIndex: T,
        selectHighlightedItem: R,
        setHighlightedIndex: S,
        clearSelection: N,
        clearItems: j,
        setItemCount: Y,
        unsetItemCount: I,
        setState: U,
        // props
        itemToString: h,
        // derived
        id: f,
        // state
        highlightedIndex: u,
        inputValue: d,
        isOpen: m,
        selectedItem: _
      };
    }, o.componentDidMount = function() {
      var e = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && kt(this._menuNode, this.getMenuProps);
      {
        var u = function() {
          e.isMouseDown = !0;
        }, d = function(V) {
          e.isMouseDown = !1;
          var L = Ae(V.target, [e._rootNode, e._menuNode], e.props.environment);
          !L && e.getState().isOpen && e.reset({
            type: Gt
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, _ = function() {
          e.isTouchMove = !1;
        }, m = function() {
          e.isTouchMove = !0;
        }, h = function(V) {
          var L = Ae(V.target, [e._rootNode, e._menuNode], e.props.environment, !1);
          !e.isTouchMove && !L && e.getState().isOpen && e.reset({
            type: an
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, f = this.props.environment;
        f.addEventListener("mousedown", u), f.addEventListener("mouseup", d), f.addEventListener("touchstart", _), f.addEventListener("touchmove", m), f.addEventListener("touchend", h), this.cleanup = function() {
          e.internalClearTimeouts(), e.updateStatus.cancel(), f.removeEventListener("mousedown", u), f.removeEventListener("mouseup", d), f.removeEventListener("touchstart", _), f.removeEventListener("touchmove", m), f.removeEventListener("touchend", h);
        };
      }
    }, o.shouldScroll = function(e, u) {
      var d = this.props.highlightedIndex === void 0 ? this.getState() : this.props, _ = d.highlightedIndex, m = u.highlightedIndex === void 0 ? e : u, h = m.highlightedIndex, f = _ && this.getState().isOpen && !e.isOpen, D = _ !== h;
      return f || D;
    }, o.componentDidUpdate = function(e, u) {
      process.env.NODE_ENV !== "production" && (nt(this.state, e, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && kt(this._menuNode, this.getMenuProps)), Xe(this.props, "selectedItem") && this.props.selectedItemChanged(e.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: sn,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(u, e) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var e = Vt(this.props.children, ie);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var u = Vt(e(this.getStateAndHelpers()));
      if (!u)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && ir(u, this.getRootProps), u;
      if (Yt(u))
        return /* @__PURE__ */ wn(u, this.getRootProps(Wt(u)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, r;
  }(On);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Ft,
    itemToString: function(r) {
      return r == null ? "" : (process.env.NODE_ENV !== "production" && Xn(r) && !r.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", r), String(r));
    },
    onStateChange: ie,
    onInputValueChange: ie,
    onUserAction: ie,
    onChange: ie,
    onSelect: ie,
    onOuterClick: ie,
    selectedItemChanged: function(r, o) {
      return r !== o;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(r, o) {
      return o;
    },
    suppressRefError: !1,
    scrollIntoView: Lt
  }, t.stateChangeTypes = Zn, t;
}();
process.env.NODE_ENV !== "production" && (or.propTypes = {
  children: l.func,
  defaultHighlightedIndex: l.number,
  defaultIsOpen: l.bool,
  initialHighlightedIndex: l.number,
  initialSelectedItem: l.any,
  initialInputValue: l.string,
  initialIsOpen: l.bool,
  getA11yStatusMessage: l.func,
  itemToString: l.func,
  onChange: l.func,
  onSelect: l.func,
  onStateChange: l.func,
  onInputValueChange: l.func,
  onUserAction: l.func,
  onOuterClick: l.func,
  selectedItemChanged: l.func,
  stateReducer: l.func,
  itemCount: l.number,
  id: l.string,
  environment: l.shape({
    addEventListener: l.func,
    removeEventListener: l.func,
    document: l.shape({
      getElementById: l.func,
      activeElement: l.any,
      body: l.any
    })
  }),
  suppressRefError: l.bool,
  scrollIntoView: l.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: l.any,
  isOpen: l.bool,
  inputValue: l.string,
  highlightedIndex: l.number,
  labelId: l.string,
  inputId: l.string,
  menuId: l.string,
  getItemId: l.func
  /* eslint-enable react/no-unused-prop-types */
});
function kt(t, n) {
  var r = n.refKey;
  t || console.error('downshift: The ref prop "' + r + '" from getMenuProps was not applied correctly on your menu element.');
}
function ir(t, n) {
  var r = n.refKey, o = r !== "ref", i = !Yt(t);
  i && !o && !Rt.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + r + '"'), !Rt.isForwardRef(t) && !Wt(t)[r] && console.error('downshift: You must apply the ref prop "' + r + '" from getRootProps onto your root element.');
}
var ur = ["isInitialMount", "highlightedIndex", "items", "environment"], cn = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function sr(t, n, r) {
  var o = t.props, i = t.type, e = {};
  Object.keys(n).forEach(function(u) {
    ar(u, t, n, r), r[u] !== n[u] && (e[u] = r[u]);
  }), o.onStateChange && Object.keys(e).length && o.onStateChange(F({
    type: i
  }, e));
}
function ar(t, n, r, o) {
  var i = n.props, e = n.type, u = "on" + rt(t) + "Change";
  i[u] && o[t] !== void 0 && o[t] !== r[t] && i[u](F({
    type: e
  }, o));
}
function cr(t, n) {
  return n.changes;
}
function lr(t) {
  var n = t.selectedItem, r = t.itemToString;
  return n ? r(n) + " has been selected." : "";
}
var dr = He(function(t, n) {
  Ut(t(), n);
}, 200), fr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? xn : se;
function pr(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + jt() : n, o = t.labelId, i = t.menuId, e = t.getItemId, u = t.toggleButtonId, d = t.inputId, _ = re({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: e || function(m) {
      return r + "-item-" + m;
    },
    toggleButtonId: u || r + "-toggle-button",
    inputId: d || r + "-input"
  });
  return _.current;
}
function gr(t, n, r, o) {
  var i, e;
  if (t === void 0) {
    if (n === void 0)
      throw new Error(o);
    i = r[n], e = n;
  } else
    e = n === void 0 ? r.indexOf(t) : n, i = t;
  return [i, e];
}
function hr(t) {
  return t ? String(t) : "";
}
function vr(t) {
  return /^\S{1}$/.test(t);
}
function rt(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function ln(t) {
  var n = re(t);
  return n.current = t, n;
}
function mr(t, n, r) {
  var o = re(), i = re(), e = ne(function(D, V) {
    i.current = V, D = Me(D, V.props);
    var L = t(D, V), k = V.props.stateReducer(D, F({}, V, {
      changes: L
    }));
    return k;
  }, [t]), u = Sn(e, n), d = u[0], _ = u[1], m = ln(r), h = ne(function(D) {
    return _(F({
      props: m.current
    }, D));
  }, [m]), f = i.current;
  return se(function() {
    f && o.current && o.current !== d && sr(f, Me(o.current, f.props), d), o.current = d;
  }, [d, r, f]), [d, h];
}
function _r(t, n, r) {
  var o = mr(t, n, r), i = o[0], e = o[1];
  return [Me(i, r), e];
}
var we = {
  itemToString: hr,
  stateReducer: cr,
  getA11ySelectionMessage: lr,
  scrollIntoView: Lt,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function le(t, n, r) {
  r === void 0 && (r = cn);
  var o = t["default" + rt(n)];
  return o !== void 0 ? o : r[n];
}
function De(t, n, r) {
  r === void 0 && (r = cn);
  var o = t[n];
  if (o !== void 0)
    return o;
  var i = t["initial" + rt(n)];
  return i !== void 0 ? i : le(t, n, r);
}
function yr(t) {
  var n = De(t, "selectedItem"), r = De(t, "isOpen"), o = De(t, "highlightedIndex"), i = De(t, "inputValue");
  return {
    highlightedIndex: o < 0 && n && r ? t.items.indexOf(n) : o,
    isOpen: r,
    selectedItem: n,
    inputValue: i
  };
}
function Ve(t, n, r) {
  var o = t.items, i = t.initialHighlightedIndex, e = t.defaultHighlightedIndex, u = n.selectedItem, d = n.highlightedIndex;
  return o.length === 0 ? -1 : i !== void 0 && d === i ? i : e !== void 0 ? e : u ? o.indexOf(u) : r === 0 ? -1 : r < 0 ? o.length - 1 : 0;
}
function Ir(t, n, r, o) {
  var i = re({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return se(function() {
    if (r?.addEventListener != null) {
      var e = function() {
        i.current.isMouseDown = !0;
      }, u = function(f) {
        i.current.isMouseDown = !1, t && !Ae(f.target, n.map(function(D) {
          return D.current;
        }), r) && o();
      }, d = function() {
        i.current.isTouchMove = !1;
      }, _ = function() {
        i.current.isTouchMove = !0;
      }, m = function(f) {
        t && !i.current.isTouchMove && !Ae(f.target, n.map(function(D) {
          return D.current;
        }), r, !1) && o();
      };
      return r.addEventListener("mousedown", e), r.addEventListener("mouseup", u), r.addEventListener("touchstart", d), r.addEventListener("touchmove", _), r.addEventListener("touchend", m), function() {
        r.removeEventListener("mousedown", e), r.removeEventListener("mouseup", u), r.removeEventListener("touchstart", d), r.removeEventListener("touchmove", _), r.removeEventListener("touchend", m);
      };
    }
  }, [t, r]), i;
}
var dn = function() {
  return ie;
};
process.env.NODE_ENV !== "production" && (dn = function() {
  for (var n = re(!0), r = arguments.length, o = new Array(r), i = 0; i < r; i++)
    o[i] = arguments[i];
  var e = re(o.reduce(function(d, _) {
    return d[_] = {}, d;
  }, {}));
  se(function() {
    Object.keys(e.current).forEach(function(d) {
      var _ = e.current[d];
      if (n.current && !Object.keys(_).length) {
        console.error("downshift: You forgot to call the " + d + " getter function on your component / element.");
        return;
      }
      var m = _.suppressRefError, h = _.refKey, f = _.elementRef;
      (!f || !f.current) && !m && console.error('downshift: The ref prop "' + h + '" from ' + d + " was not applied correctly on your element.");
    }), n.current = !1;
  });
  var u = ne(function(d, _, m, h) {
    e.current[d] = {
      suppressRefError: _,
      refKey: m,
      elementRef: h
    };
  }, []);
  return u;
});
function $t(t, n, r) {
  var o = r.isInitialMount, i = r.highlightedIndex, e = r.items, u = r.environment, d = ce(r, ur);
  se(function() {
    o || dr(function() {
      return t(F({
        highlightedIndex: i,
        highlightedItem: e[i],
        resultCount: e.length
      }, d));
    }, u.document);
  }, n);
}
function Er(t) {
  var n = t.highlightedIndex, r = t.isOpen, o = t.itemRefs, i = t.getItemNodeFromIndex, e = t.menuElement, u = t.scrollIntoView, d = re(!0);
  return fr(function() {
    n < 0 || !r || !Object.keys(o.current).length || (d.current === !1 ? d.current = !0 : u(i(n), e));
  }, [n]), d;
}
var fn = ie;
process.env.NODE_ENV !== "production" && (fn = function(n) {
  var r = n.isInitialMount, o = n.props, i = n.state, e = re(o);
  se(function() {
    r || (nt(i, e.current, o), e.current = o);
  }, [i, o, r]);
});
function Ht(t, n, r) {
  var o;
  r === void 0 && (r = !0);
  var i = ((o = t.items) == null ? void 0 : o.length) && n >= 0;
  return F({
    isOpen: !1,
    highlightedIndex: -1
  }, i && F({
    selectedItem: t.items[n],
    isOpen: le(t, "isOpen"),
    highlightedIndex: le(t, "highlightedIndex")
  }, r && {
    inputValue: t.itemToString(t.items[n])
  }));
}
function br(t, n, r) {
  var o = n.type, i = n.props, e;
  switch (o) {
    case r.ItemMouseMove:
      e = {
        highlightedIndex: n.disabled ? -1 : n.index
      };
      break;
    case r.MenuMouseLeave:
      e = {
        highlightedIndex: -1
      };
      break;
    case r.ToggleButtonClick:
    case r.FunctionToggleMenu:
      e = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : Ve(i, t, 0)
      };
      break;
    case r.FunctionOpenMenu:
      e = {
        isOpen: !0,
        highlightedIndex: Ve(i, t, 0)
      };
      break;
    case r.FunctionCloseMenu:
      e = {
        isOpen: !1
      };
      break;
    case r.FunctionSetHighlightedIndex:
      e = {
        highlightedIndex: n.highlightedIndex
      };
      break;
    case r.FunctionSetInputValue:
      e = {
        inputValue: n.inputValue
      };
      break;
    case r.FunctionReset:
      e = {
        highlightedIndex: le(i, "highlightedIndex"),
        isOpen: le(i, "isOpen"),
        selectedItem: le(i, "selectedItem"),
        inputValue: le(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return F({}, t, e);
}
function wr(t) {
  for (var n = t.keysSoFar, r = t.highlightedIndex, o = t.items, i = t.itemToString, e = t.getItemNodeFromIndex, u = n.toLowerCase(), d = 0; d < o.length; d++) {
    var _ = (d + r + (n.length < 2 ? 1 : 0)) % o.length, m = o[_];
    if (m !== void 0 && i(m).toLowerCase().startsWith(u)) {
      var h = e(_);
      if (!h?.hasAttribute("disabled"))
        return _;
    }
  }
  return r;
}
var Or = {
  items: l.array.isRequired,
  itemToString: l.func,
  getA11yStatusMessage: l.func,
  getA11ySelectionMessage: l.func,
  highlightedIndex: l.number,
  defaultHighlightedIndex: l.number,
  initialHighlightedIndex: l.number,
  isOpen: l.bool,
  defaultIsOpen: l.bool,
  initialIsOpen: l.bool,
  selectedItem: l.any,
  initialSelectedItem: l.any,
  defaultSelectedItem: l.any,
  id: l.string,
  labelId: l.string,
  menuId: l.string,
  getItemId: l.func,
  toggleButtonId: l.string,
  stateReducer: l.func,
  onSelectedItemChange: l.func,
  onHighlightedIndexChange: l.func,
  onStateChange: l.func,
  onIsOpenChange: l.func,
  environment: l.shape({
    addEventListener: l.func,
    removeEventListener: l.func,
    document: l.shape({
      getElementById: l.func,
      activeElement: l.any,
      body: l.any
    })
  })
};
function xr(t) {
  var n = t.isOpen, r = t.resultCount, o = t.previousResultCount;
  return n ? r ? r !== o ? "".concat(r, " result").concat(r === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
var Sr = mt(mt({}, we), { getA11yStatusMessage: xr }), pn = ie;
process.env.NODE_ENV !== "production" && (pn = function(t, n) {
  l.checkPropTypes(Or, t, "prop", n.name);
});
var Pe = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, ot = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, it = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, ke = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, ut = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, st = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, at = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, ct = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, lt = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, dt = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, ft = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, $e = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, gn = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, hn = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, pt = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, vn = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, mn = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, _n = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, yn = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, gt = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Qe = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, In = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, En = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ToggleButtonClick: Pe,
  ToggleButtonKeyDownArrowDown: ot,
  ToggleButtonKeyDownArrowUp: it,
  ToggleButtonKeyDownCharacter: ke,
  ToggleButtonKeyDownEscape: ut,
  ToggleButtonKeyDownHome: st,
  ToggleButtonKeyDownEnd: at,
  ToggleButtonKeyDownEnter: ct,
  ToggleButtonKeyDownSpaceButton: lt,
  ToggleButtonKeyDownPageUp: dt,
  ToggleButtonKeyDownPageDown: ft,
  ToggleButtonBlur: $e,
  MenuMouseLeave: gn,
  ItemMouseMove: hn,
  ItemClick: pt,
  FunctionToggleMenu: vn,
  FunctionOpenMenu: mn,
  FunctionCloseMenu: _n,
  FunctionSetHighlightedIndex: yn,
  FunctionSelectItem: gt,
  FunctionSetInputValue: Qe,
  FunctionReset: In
});
function Cr(t, n) {
  var r, o = n.type, i = n.props, e = n.altKey, u;
  switch (o) {
    case pt:
      u = {
        isOpen: le(i, "isOpen"),
        highlightedIndex: le(i, "highlightedIndex"),
        selectedItem: i.items[n.index]
      };
      break;
    case ke:
      {
        var d = n.key, _ = "" + t.inputValue + d, m = !t.isOpen && t.selectedItem ? i.items.indexOf(t.selectedItem) : t.highlightedIndex, h = wr({
          keysSoFar: _,
          highlightedIndex: m,
          items: i.items,
          itemToString: i.itemToString,
          getItemNodeFromIndex: n.getItemNodeFromIndex
        });
        u = {
          inputValue: _,
          highlightedIndex: h,
          isOpen: !0
        };
      }
      break;
    case ot:
      {
        var f = t.isOpen ? ge(1, t.highlightedIndex, i.items.length, n.getItemNodeFromIndex, !1) : e && t.selectedItem == null ? -1 : Ve(i, t, 1);
        u = {
          highlightedIndex: f,
          isOpen: !0
        };
      }
      break;
    case it:
      if (t.isOpen && e)
        u = Ht(i, t.highlightedIndex, !1);
      else {
        var D = t.isOpen ? ge(-1, t.highlightedIndex, i.items.length, n.getItemNodeFromIndex, !1) : Ve(i, t, -1);
        u = {
          highlightedIndex: D,
          isOpen: !0
        };
      }
      break;
    case ct:
    case lt:
      u = Ht(i, t.highlightedIndex, !1);
      break;
    case st:
      u = {
        highlightedIndex: he(1, 0, i.items.length, n.getItemNodeFromIndex, !1),
        isOpen: !0
      };
      break;
    case at:
      u = {
        highlightedIndex: he(-1, i.items.length - 1, i.items.length, n.getItemNodeFromIndex, !1),
        isOpen: !0
      };
      break;
    case dt:
      u = {
        highlightedIndex: ge(-10, t.highlightedIndex, i.items.length, n.getItemNodeFromIndex, !1)
      };
      break;
    case ft:
      u = {
        highlightedIndex: ge(10, t.highlightedIndex, i.items.length, n.getItemNodeFromIndex, !1)
      };
      break;
    case ut:
      u = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case $e:
      u = F({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((r = i.items) == null ? void 0 : r.length) && {
        selectedItem: i.items[t.highlightedIndex]
      });
      break;
    case gt:
      u = {
        selectedItem: n.selectedItem
      };
      break;
    default:
      return br(t, n, En);
  }
  return F({}, t, u);
}
var Tr = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"], Dr = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], Rr = ["item", "index", "onMouseMove", "onClick", "onPress", "refKey", "ref", "disabled"];
ht.stateChangeTypes = En;
function ht(t) {
  t === void 0 && (t = {}), pn(t, ht);
  var n = F({}, Sr, t), r = n.items, o = n.scrollIntoView, i = n.environment, e = n.itemToString, u = n.getA11ySelectionMessage, d = n.getA11yStatusMessage, _ = yr(n), m = _r(Cr, _, n), h = m[0], f = m[1], D = h.isOpen, V = h.highlightedIndex, L = h.selectedItem, k = h.inputValue, B = re(null), O = re(null), s = re({}), p = re(null), a = pr(n), c = re(), T = re(!0), R = ln({
    state: h,
    props: n
  }), S = ne(function(E) {
    return s.current[a.getItemId(E)];
  }, [a]);
  $t(d, [D, V, k, r], F({
    isInitialMount: T.current,
    previousResultCount: c.current,
    items: r,
    environment: i,
    itemToString: e
  }, h)), $t(u, [L], F({
    isInitialMount: T.current,
    previousResultCount: c.current,
    items: r,
    environment: i,
    itemToString: e
  }, h));
  var N = Er({
    menuElement: O.current,
    highlightedIndex: V,
    isOpen: D,
    itemRefs: s,
    scrollIntoView: o,
    getItemNodeFromIndex: S
  });
  se(function() {
    return p.current = He(function(E) {
      E({
        type: Qe,
        inputValue: ""
      });
    }, 500), function() {
      p.current.cancel();
    };
  }, []), se(function() {
    k && p.current(f);
  }, [f, k]), fn({
    isInitialMount: T.current,
    props: n,
    state: h
  }), se(function() {
    T.current || (c.current = r.length);
  });
  var j = Ir(D, [O, B], i, function() {
    f({
      type: $e
    });
  }), P = dn("getMenuProps", "getToggleButtonProps");
  se(function() {
    return T.current = !1, function() {
      T.current = !0;
    };
  }, []), se(function() {
    D || (s.current = {});
  }, [D]);
  var Y = bn(function() {
    return {
      ArrowDown: function(x) {
        x.preventDefault(), f({
          type: ot,
          getItemNodeFromIndex: S,
          altKey: x.altKey
        });
      },
      ArrowUp: function(x) {
        x.preventDefault(), f({
          type: it,
          getItemNodeFromIndex: S,
          altKey: x.altKey
        });
      },
      Home: function(x) {
        x.preventDefault(), f({
          type: st,
          getItemNodeFromIndex: S
        });
      },
      End: function(x) {
        x.preventDefault(), f({
          type: at,
          getItemNodeFromIndex: S
        });
      },
      Escape: function() {
        R.current.state.isOpen && f({
          type: ut
        });
      },
      Enter: function(x) {
        x.preventDefault(), f({
          type: R.current.state.isOpen ? ct : Pe
        });
      },
      PageUp: function(x) {
        R.current.state.isOpen && (x.preventDefault(), f({
          type: dt,
          getItemNodeFromIndex: S
        }));
      },
      PageDown: function(x) {
        R.current.state.isOpen && (x.preventDefault(), f({
          type: ft,
          getItemNodeFromIndex: S
        }));
      },
      " ": function(x) {
        x.preventDefault();
        var y = R.current.state;
        if (!y.isOpen) {
          f({
            type: Pe
          });
          return;
        }
        y.inputValue ? f({
          type: ke,
          key: " ",
          getItemNodeFromIndex: S
        }) : f({
          type: lt
        });
      }
    };
  }, [f, S, R]), I = ne(function() {
    f({
      type: vn
    });
  }, [f]), U = ne(function() {
    f({
      type: _n
    });
  }, [f]), W = ne(function() {
    f({
      type: mn
    });
  }, [f]), Z = ne(function(E) {
    f({
      type: yn,
      highlightedIndex: E
    });
  }, [f]), ee = ne(function(E) {
    f({
      type: gt,
      selectedItem: E
    });
  }, [f]), oe = ne(function() {
    f({
      type: In
    });
  }, [f]), ue = ne(function(E) {
    f({
      type: Qe,
      inputValue: E
    });
  }, [f]), g = ne(function(E) {
    return F({
      id: a.labelId,
      htmlFor: a.toggleButtonId
    }, E);
  }, [a]), w = ne(function(E, x) {
    var y, C = E === void 0 ? {} : E, M = C.onMouseLeave, K = C.refKey, A = K === void 0 ? "ref" : K;
    C.onKeyDown, C.onBlur;
    var b = C.ref, v = ce(C, Tr), J = x === void 0 ? {} : x, Q = J.suppressRefError, de = Q === void 0 ? !1 : Q, fe = function() {
      f({
        type: gn
      });
    };
    return P("getMenuProps", de, A, O), F((y = {}, y[A] = be(b, function(ve) {
      O.current = ve;
    }), y.id = a.menuId, y.role = "listbox", y["aria-labelledby"] = v && v["aria-label"] ? void 0 : "" + a.labelId, y.onMouseLeave = te(M, fe), y), v);
  }, [f, P, a]), H = ne(function(E, x) {
    var y, C = E === void 0 ? {} : E, M = C.onBlur, K = C.onClick;
    C.onPress;
    var A = C.onKeyDown, b = C.refKey, v = b === void 0 ? "ref" : b, J = C.ref, Q = ce(C, Dr), de = x === void 0 ? {} : x, fe = de.suppressRefError, ve = fe === void 0 ? !1 : fe, me = R.current.state, xe = function() {
      f({
        type: Pe
      });
    }, Be = function() {
      me.isOpen && !j.current.isMouseDown && f({
        type: $e
      });
    }, pe = function(ye) {
      var ae = Je(ye);
      ae && Y[ae] ? Y[ae](ye) : vr(ae) && f({
        type: ke,
        key: ae,
        getItemNodeFromIndex: S
      });
    }, Ie = F((y = {}, y[v] = be(J, function(_e) {
      B.current = _e;
    }), y["aria-activedescendant"] = me.isOpen && me.highlightedIndex > -1 ? a.getItemId(me.highlightedIndex) : "", y["aria-controls"] = a.menuId, y["aria-expanded"] = R.current.state.isOpen, y["aria-haspopup"] = "listbox", y["aria-labelledby"] = Q && Q["aria-label"] ? void 0 : "" + a.labelId, y.id = a.toggleButtonId, y.role = "combobox", y.tabIndex = 0, y.onBlur = te(M, Be), y), Q);
    return Q.disabled || (Ie.onClick = te(K, xe), Ie.onKeyDown = te(A, pe)), P("getToggleButtonProps", ve, v, B), Ie;
  }, [R, a, P, f, j, Y, S]), $ = ne(function(E) {
    var x, y = E === void 0 ? {} : E, C = y.item, M = y.index, K = y.onMouseMove, A = y.onClick;
    y.onPress;
    var b = y.refKey, v = b === void 0 ? "ref" : b, J = y.ref, Q = y.disabled, de = ce(y, Rr), fe = R.current, ve = fe.state, me = fe.props, xe = gr(C, M, me.items, "Pass either item or index to getItemProps!"), Be = xe[0], pe = xe[1], Ie = function() {
      pe !== ve.highlightedIndex && (N.current = !1, f({
        type: hn,
        index: pe,
        disabled: Q
      }));
    }, _e = function() {
      f({
        type: pt,
        index: pe
      });
    }, ye = F((x = {
      disabled: Q,
      role: "option",
      "aria-selected": "" + (Be === L),
      id: a.getItemId(pe)
    }, x[v] = be(J, function(ae) {
      ae && (s.current[a.getItemId(pe)] = ae);
    }), x), de);
    return Q || (ye.onClick = te(A, _e)), ye.onMouseMove = te(K, Ie), ye;
  }, [R, L, a, N, f]);
  return {
    // prop getters.
    getToggleButtonProps: H,
    getLabelProps: g,
    getMenuProps: w,
    getItemProps: $,
    // actions.
    toggleMenu: I,
    openMenu: W,
    closeMenu: U,
    setHighlightedIndex: Z,
    selectItem: ee,
    reset: oe,
    setInputValue: ue,
    // state.
    highlightedIndex: V,
    isOpen: D,
    selectedItem: L,
    inputValue: k
  };
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
l.array.isRequired, l.func, l.func, l.func, l.func, l.number, l.number, l.number, l.bool, l.bool, l.bool, l.any, l.any, l.any, l.string, l.string, l.string, l.string, l.string, l.string, l.func, l.string, l.string, l.func, l.func, l.func, l.func, l.func, l.func, l.shape({
  addEventListener: l.func,
  removeEventListener: l.func,
  document: l.shape({
    getElementById: l.func,
    activeElement: l.any,
    body: l.any
  })
});
process.env.NODE_ENV;
F({}, we, {
  selectedItemChanged: function(n, r) {
    return n !== r;
  },
  getA11yStatusMessage: Ft
});
function Nr(t) {
  var n = t.removedSelectedItem, r = t.itemToString;
  return r(n) + " has been removed.";
}
l.array, l.array, l.array, l.func, l.func, l.func, l.number, l.number, l.number, l.func, l.func, l.string, l.string, l.shape({
  addEventListener: l.func,
  removeEventListener: l.func,
  document: l.shape({
    getElementById: l.func,
    activeElement: l.any,
    body: l.any
  })
});
we.itemToString, we.stateReducer, we.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const Pr = Oe.div`
  position: relative;
`, Mr = Oe.button`
  background-color: ${(t) => t.theme.components.select.backgroundColor};
  border: 1px solid #cccccc;
  border-radius: ${Nn["1x"]};
  color: ${(t) => t.theme.components.select.labelColor};
  padding: ${et["2x"]};
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div.svg {
    transition: transform 0.2s ease-in-out;
    transform: ${({ isOpen: t }) => t ? "rotate(180deg)" : "rotate(0deg)"};
  }
`, Ar = Oe.ul`
  background-color: ${(t) => t.theme.components.select.backgroundColor};
  border: 1px solid
    ${(t) => t.theme.components.select.borderColorDefault};
  border-radius: ${Pn["4x"]};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  list-style-type: none;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
`, Vr = Oe.li`
  cursor: pointer;
  padding: ${et["2x"]};
  &:hover {
    background-color: ${(t) => t.theme.components.select.labelColor};
  }
`, kr = Oe.span`
  padding: ${et["2x"]};
`, Ur = Cn(({ options: t, onSelect: n }, r) => {
  const {
    isOpen: o,
    selectedItem: i,
    highlightedIndex: e,
    getToggleButtonProps: u,
    getMenuProps: d,
    getItemProps: _
  } = ht({
    items: t,
    onSelectedItemChange: ({ selectedItem: m }) => {
      n(m);
    }
  });
  return /* @__PURE__ */ vt(Pr, { children: [
    /* @__PURE__ */ vt(Mr, { isOpen: o, ...u(), children: [
      i ? i.label : "Select an option",
      /* @__PURE__ */ Ee(kr, { children: o ? /* @__PURE__ */ Ee(Rn, { "aria-hidden": !0 }) : /* @__PURE__ */ Ee(Dn, { "aria-hidden": !0 }) })
    ] }),
    o && /* @__PURE__ */ Ee(Ar, { ref: r, ...d(), children: t.map((m, h) => /* @__PURE__ */ Ee(
      Vr,
      {
        ..._({
          key: m.value,
          index: h,
          item: m,
          style: {
            backgroundColor: e === h ? "#f5f5f5" : "transparent",
            fontWeight: i === m ? "bold" : "normal"
          }
        }),
        children: m.label
      }
    )) })
  ] });
});
export {
  Ur as Select
};
